namespace advisorop.components.common {

    export class AccountListController {

        accountStatus: number; //0-active, 1-active and closed, 1-not finished
        public accounts: Array<domains.IAccount>;
        public dg: DevExpress.ui.dxDataGridOptions;
        showClosedAccounts: boolean = false;
        investorId: number;
        householdId: number;
        preview: boolean = true;
        adminMode: boolean = false;
        mvDate: Date = null;
        public $router;
        allowRename: number;
        showClosedOption: number;
        filterable: number;
        user: domains.identity.IUser;
        impersonatedByServicer: boolean = false;
        lovs: Array<domains.ILOV> = [];
        accountTypes: Array<domains.ILOV> = [];
        filterByAccountType: boolean = false;
        selAccountType: domains.ILOV;


        accountFilter: domains.IAccountFilter = {
            custodianId: null,
            accountTypeId: null,
            advisoryFirmMgtRoleId: null,
            productTypeId: null,
            aumFeeableOnly: false,
            manualAccountsOnly: false
        };

        menuData: any[];
        pp: DevExpress.ui.dxContextMenuOptions;

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#accountListContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading accounts list...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["advisorService", "identityService", "generalService", "$rootRouter", "$rootScope"];
        constructor(
            private advisorService: services.AdvisorService,
            private identityService: services.IdentityService,
            private generalService: services.GeneralService,
            private $rootRouter: any, private $rootScope: ng.IRootScopeService) {

            this.$rootScope.$on("adminModeChanged", (event: ng.IAngularEvent) => {
                this.adminMode = this.advisorService.isAdminModeEnabled();
            });

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Accounts"
                },
                bindingOptions: {
                    dataSource: "vm.accounts"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: {
                    enabled: true,
                    pageSize: 30
                },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,

                noDataText: "Account Not Found",
                stateStoring: {
                    enabled: false,
                    type: "localStorage",
                    storageKey: "dgAccountsXY"
                },
                columnChooser: {
                    enabled: true,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    {
                        dataField: "name", caption: "Account Title", width: 160, cellTemplate: "colFullName",
                        headerFilter: {
                            allowSearch: true
                        }
                    },
                    { dataField: "householdNames", caption: "Households" },
                    //{ dataField: "investorNames", caption: "Investors" },
                    {
                        dataField: "number", caption: "Account Number", headerFilter: {
                            allowSearch: true
                        }
                    },
                    {
                        dataField: "usdMarketValue", caption: "Market Value", format: "currency", visible: this.showMarketValue(), headerFilter: {
                            groupInterval: 10000
                        }
                    },
                    { dataField: "accountTypeDescription", caption: "Account Type" },
                    { dataField: "productTypeDescription", caption: "Product Type" },
                    { dataField: "advisoryFirm.advisoryFirmName", caption: "Advisory Firm" },
                    { dataField: "custodianName", caption: "Custodian" },
                    //{ dataField: "titleTypeDescription", caption: "Type", width: 90 },
                    { dataField: "advisoryFirmMgtRoleDescription", caption: "Advisor Role" },
                    { dataField: "discretion", caption: "Discretion" },
                    { dataField: "directManagerDesc", caption: "Manager (Product)" },
                    { dataField: "directManagerProductDesc", caption: "Investment Product" },
                    { dataField: "billingScheduleName", caption: "Billing" },
                    { dataField: "isManualAccount", caption: "Manual Acct?" },
                    { dataField: "manualAccountType", caption: "Manual Acct Type" },
                    { dataField: "primaryAdvisorsStr", caption: "Primary Advisor(s)" },
                    { dataField: "secondaryAdvisorsStr", caption: "Secondary Advisor(s)" },
                    { dataField: "leadAnalystsStr", caption: "Lead Analyst(s)" },
                    { dataField: "titleTypeDescription", caption: "Title Type" },
                    { dataField: "titleSubtypeDescription", caption: "Title Subtype" },
                    //{ dataField: "entitySubtype", caption: "Entity Subtype" },
                    { dataField: "investorNames", caption: "Investor(s)" },
                    { dataField: "investorStates", caption: "Investor State(s)" },
                    { dataField: "investorEntityTypes", caption: "Investor Entity Type(s)" },
                    { dataField: "dateCreated", caption: "Created", dataType: "date", format: "shortDate" },
                    { dataField: "statusDescription", caption: "Status" },
                    { dataField: "managerAndProduct", caption: "Product" },
                    //{ dataField: "manualAccount.manualAccountHoldingTypeDescription", caption: "Manual Account Type", width: 90 },
                    //{ dataField: "id", caption: "Actions", cellTemplate: "btnActions", cssClass: "tblOverflow" }
                ],
                summary: {
                    totalItems: 
                        [{
                            column: "name",
                            name: "Accounts",
                            summaryType: "count"
                        }, {
                            column: "usdMarketValue",
                            name: "Market Value",
                            valueFormat: "currency",
                            summaryType: "sum"
                        }
                        ]
                },

                onContextMenuPreparing: (e: any) => {
                    e.items = [];
                    //console.log("E: ", e); 
                    //console.log("E ROWINDEX: ", e.rowIndex);
                    if (e.rowIndex > -1) { // context menu does not work for detail rows in master-detail
                        if (e.row.rowType == "data") {
                            //console.log("Data: ", e.row.data, this.$rootRouter, this.$router);
                            let managed = e.row.data.advisoryFirmMgtRole == domains.AdvisoryFirmMgtRole.MANAGED;
                            let hasProposal = (e.row.data.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS
                                || e.row.data.accountType == domains.InvestmentType.MANAGED_MODELS
                                || e.row.data.accountType == domains.InvestmentType.SMA);

                            // account-summary.html tab numbers are below for reference.
                            // it does not look like uib - tab supports index names as strings so we are using numbers.
                            //Tab 0: "General Information"
                            //Tab 2: "Outside Holdings"
                            //Tab 3: "Proposals"
                            //Tab 4: "Households and Groups"
                            //Tab 5: "Audit Account"
                            //Tab 6: "Edit Details"
                            //Tab 7: "Documentation"

                            e.items.push({ text: "Account Summary", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 0) });
                            if (e.row.data.status != domains.AccountStatus.SETUP) {
                                if (hasProposal) {
                                    e.items.push({ text: "Proposals", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 3) });
                                }
                                e.items.push({ text: "Households and Groups", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 4) });
                            }
                            e.items.push({ text: "Documentation", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 7) });

                            if (managed) {
                                if (!this.adminMode && e.row.data.status == domains.AccountStatus.OPEN) {
                                    e.items.push({ text: "Assign RTG", onItemClick: () => this.onContextMenuItemClick(e, "AssignAccountRTG") });
                                }
                                // reports for managed accounts
                                //if (e.row.data.status >= domains.AccountStatus.OPENING) {
                                //    e.items.push({
                                //        text: "Reports", items: [
                                //            { text: "RTQ", onItemClick: () => window.open(`api/advisor/getrtqxtrareport/${e.row.data.id}/0`, "_blank") },
                                //            //{ text: "Proposal", onItemClick: () => window.open(`api/advisor/getproposalsimplereport/${e.row.data.id}/0`, "_blank") },
                                //            //{ text: "Pershing Agreement", onItemClick: () => window.open(`api/advisor/getpershopformreportforaccount/${e.row.data.id}/0`, "_blank") },
                                //            //{ text: "Subscription Agreement", onItemClick: () => window.open(`api/advisor/generatesubscriptionagreement/${e.row.data.id}/0`, "_blank") }
                                //        ]
                                //    })
                                //};
                            } else {
                                if (!this.adminMode && e.row.data.status == domains.AccountStatus.OPEN) {
                                    e.items.push({ text: "Assign Household", onItemClick: () => this.onContextMenuItemClick(e, "AssignHousehold") });
                                }
                            }
                            if (!this.adminMode) {
                                if (e.row.data.status <= domains.AccountStatus.SETUP) {
                                    // only users that are impersonated by servicers can reenter the new account workflow or can cancel accounts
                                    if (e.row.data.accountType != domains.InvestmentType.CUSTODIAN_ACCOUNT && this.impersonatedByServicer) {
                                        //e.items.push({ text: "Continue With Wizard", onItemClick: () => this.onContextMenuItemClick(e, "UpdateAccount") });
                                        e.items.push({ text: "Continue Account Opening", onItemClick: () => this.onContextMenuItemClick(e, "NewUpdateAccount") });
                                    }
                                    if (this.impersonatedByServicer) {
                                        e.items.push({ text: "Cancel Account", onItemClick: () => this.cancelAccount(e.row.data) });
                                    }
                                } //else if (e.row.data.status == domains.AccountStatus.OPEN) {
                                    //e.items.push({ text: "Close Account", onItemClick: () => this.closeAccount(e.row.data) });
                                //}

                                // Only allow renaming when we are looking at the accounts list in its own screen (i.e. we are not in dashboards)
                                // because when in dashboards we would need to refresh the dashboards to pick up the name change...
                                // Here we are just updating the local list of accounts.
                                if (this.allowRename && this.allowRename > 0) {
                                    e.items.push({ text: "Rename Account", onItemClick: () => this.renameAccount(e.row.data) });
                                }

                                // If we want to add this item in later, then we will need to add productDescription to the grid,
                                // also if this is on the HHH dashboard then we will want to refresh (reload) the dashboard after saving this change.
                                //
                                //if (e.row.data.account.accountType <= domains.InvestmentType.CUSTODIAN_ACCOUNT) {
                                //    e.items.push({ text: "Change Product Description", onItemClick: () => this.changeProductDescription(e.row.data) });
                                //}
                            }
                        }
                    }
                },
                onCellPrepared: function (e: any) {
                    if (e.rowType == "data" && e.column.command == "expand") {
                        //console.log("onCellPrepared - ", e);
                        let subAccountsCount = (e.data.custodianSubAccounts != null) ? e.data.custodianSubAccounts.length : 0;
                        if (subAccountsCount == 0) {
                            e.cellElement.removeClass("dx-datagrid-expand");
                            e.cellElement.empty()
                        }
                    }
                },
                 onRowPrepared: function (e: any) {
                    if (e.rowType == "data") {
                        //console.log("onRowPrepared - ", e);
                        let subAccountsCount = (e.data.custodianSubAccounts != null) ? e.data.custodianSubAccounts.length : 0;
                        if (subAccountsCount == 0) {
                            e.rowElement.find('td:nth-child(1)').removeClass("dx-datagrid-group-closed");
                        }
                    }
                },
                //onCellPrepared: (e: any) => {
                    // DEMO - SIMULATION OF RIGHT MOUSE CLICK ...
                    //e.cellElement.find(".dx-datagrid-text-content").on("dxclick", function (event) {
                    //    var newEvent = $.extend({}, event, { type: "dxcontextmenu" });
                    //    event.stopPropagation();
                    //    $(this).trigger(newEvent);
                    //});
                //},
                //selection: {
                //    mode: "single",
                //    showCheckBoxesMode: "onClick"
                //},
                //onSelectionChanged: function (selectedItems) {
                //    var data = selectedItems.selectedRowsData[0];
                //    if (data) {
                //        this.vm.onInvestorChanged({ id: data.id });
                //    }
                //}
                masterDetail: {
                    enabled: true,
                    autoExpandAll: false,
                    template: "subAccounts"
                },
            };
        }

        onContextMenuItemClick(e: any, menuitem: string, navTabParam?: number) {
            let data = e.row.data;

            // navigation tab parameter - index of initial tab in next window (optional)
            let ntp = (navTabParam != null) ? navTabParam : 0;

            if (menuitem === "AssignAccountRTG") {
                //this is one option with root router , but we prefer option with child/relative router
                //this.$rootRouter.navigate(["Advisor","AssignAccountRTG", { accountId: data.id }]);
                this.$router.navigate(["AssignAccountRTG", { accountId: data.id }]);
            }
            if (menuitem === "AssignHousehold") {
                this.$router.navigate(["AssignHousehold", { accountId: data.id }]);
            }

            if (menuitem === "UpdateAccount") {
                this.$router.navigate(["UpdateAccount", { accountId: data.id }]);
            }
            if (menuitem === "NewUpdateAccount") {
                this.$router.navigate(["NewUpdateAccount", { accountId: data.id }]);
            }
            if (menuitem === "AccountSummary") {
                this.$router.navigate(["AccountSummary", { accountId: data.id, NP: ntp }]);

            }
            if (menuitem === "AssignHousehold") {
                this.$router.navigate(["AssignHousehold", { accountId: data.id }]);
            }
            if (menuitem === "AssignHousehold") {
                this.$router.navigate(["AssignHousehold", { accountId: data.id }]);
            }
        };

        reloadAccounts() {
            //console.log(this.showClosedAccounts);
            this.loadAccounts();
        };

        toggleFilterByAccountType(): void {
            if (!this.filterByAccountType) {
                this.selAccountType = null;
                this.accountFilter.accountTypeId = null;
                this.reloadAccounts();
            }
        }
        accountTypeFilterChanged(): void {
            this.accountFilter.accountTypeId = this.selAccountType.value;
        }

        loadAccounts() {

            this.mvDate = null;

            let rez: ng.IHttpPromise<domains.IAccount[]>;
            
            this.isInitializing = true;

            if (this.investorId && this.investorId > 0) {
                //console.log("Loading accounts for individual: " + this.investorId);
                rez = this.advisorService.getAccountsByInvestor(this.investorId, this.accountStatus, this.showClosedAccounts, true, true, this.accountFilter);
            }
            else if (this.householdId && this.householdId > 0) {
                //console.log("Loading accounts for household: " + this.householdId);
                rez = this.advisorService.getAccountsByHousehold(this.householdId, this.accountStatus, this.showClosedAccounts, true, true, this.accountFilter);
            }
            else {
                //console.log("Loading accounts for advisor...");
                rez = this.advisorService.getAccountsByAdvisor(this.accountStatus, this.showClosedAccounts, true, true, this.accountFilter);
            }

            rez.then(response => {
                let showMV: boolean = this.showMarketValue();
                this.accounts = response.data
                if (this.accounts.length > 0) {
                    // The Market Value Date on all account rows is the same (date from the BO table), so we can take the date from the first row.
                    this.mvDate = this.accounts[0].marketValueDate;
                }
                this.isInitializing = false;
            }).catch(err => {
                this.generalService.showError(err);
                this.isInitializing = false;
            });
        };

        cancelAccount(account: domains.IAccount) {
            if (this.adminMode) {
                toastr.info("Functionality not allowed in Admin Mode");
                return;
            }

            var msg = "YOU ARE TRYING TO CANCEL ACCOUNT: \"" + account.name
                + "\"\n\nARE YOU SURE?\n\nPRESS OK TO CONFIRM, CANCEL TO GO BACK.";

            if (window.confirm(msg)) {

                this.advisorService.cancelAccount(account)
                    .then((response) => {
                        var ind = this.accounts.indexOf(account);
                        this.accounts.splice(ind, 1);
                        toastr.success("Account has been canceled.");
                    }, err => this.generalService.showError(err) );
            }
        };

        cancelDetailAccount(detailAccount: domains.IAccount) {
            if (this.adminMode) {
                toastr.info("Functionality not allowed in Admin Mode");
                return;
            }

            var msg = "YOU ARE TRYING TO CANCEL ACCOUNT: \"" + detailAccount.name
                + "\"\n\nARE YOU SURE?\n\nPRESS OK TO CONFIRM, CANCEL TO GO BACK.";

            if (window.confirm(msg)) {
                this.advisorService.cancelAccount(detailAccount)
                    .then((response) => {
                        toastr.success("Account has been canceled.");
                        this.reloadAccounts();
                    }, err => this.generalService.showError(err));
            }
        };

        renameAccount(account: domains.IAccount) {
            let accountName = prompt("Enter new name of account", account.name);
            if (accountName && accountName.length > 0) {
                accountName = this.advisorService.replaceSlashes(accountName);
                this.advisorService.renameAccount(account.id, accountName)
                    .then(response => {
                        toastr.info("Account has been renamed");
                        account.name = accountName;
                    });
            }
        }

        //changeProductDescription(masterDetail: AccountListController["masterDetail"]) {
        //    let pd = prompt("Enter new product description", masterDetail.account.productDescription != null ? masterDetail.account.productDescription : "");
        //    if (pd && pd.length > 0) {
        //        this.advisorService.modifyProductDescription(masterDetail.account.id, pd)
        //            .then(response => {
        //                toastr.info("Product description has been updated");
        //                masterDetail.account.productDescription = pd;
        //            });
        //    }
        //}
        
        renameDetailAccount(detailAccount: domains.IAccount) {
            let accountName = prompt("Enter new name of account", detailAccount.name);
            if (accountName && accountName.length > 0) {
                accountName = this.advisorService.replaceSlashes(accountName);
                this.advisorService.renameAccount(detailAccount.id, accountName)
                    .then(response => {
                        toastr.info("Account has been renamed");
                        this.reloadAccounts();
                    });
            }
        }

        closeAccount(account: domains.IAccount) {
            if (this.adminMode) {
                toastr.info("Functionality not allowed in Admin Mode");
                return;
            }

            var msg = "YOU ARE TRYING TO CLOSE ACCOUNT: \"" + account.name
                + "\"\nAccount Number: \"" + account.number
                + "\"\n\nARE YOU SURE?\n\nPRESS OK TO CONFIRM, CANCEL TO GO BACK.";

            if (!window.confirm(msg)) {
                return;
            }

            this.advisorService.closeAccount(account)
                .then((response) => {
                    var ind = this.accounts.indexOf(account);
                    this.accounts.splice(ind, 1);
                    toastr.success("Account has been closed.");
                }, err => this.generalService.showError(err));

        };

        closeDetailAccount(detailAccount: domains.IAccount) {
            if (this.adminMode) {
                toastr.info("Functionality not allowed in Admin Mode");
                return;
            }

            var msg = "YOU ARE TRYING TO CLOSE ACCOUNT: \"" + detailAccount.name
                + "\"\nAccount Number: \"" + detailAccount.number
                + "\"\n\nARE YOU SURE?\n\nPRESS OK TO CONFIRM, CANCEL TO GO BACK.";

            if (!window.confirm(msg)) {
                return;
            }

            this.advisorService.closeAccount(detailAccount)
                .then((response) => {
                    toastr.success("Account has been closed.");
                    this.reloadAccounts();
                }, err => this.generalService.showError(err));

        };

        copyAccount(accountId: number): void {

            this.advisorService.copyAccount(accountId).then(data => {
                toastr.success("Account has been copied!");
            }, err => this.generalService.showError(err));
        };

        showMarketValue(): boolean {
            return (this.accountStatus == 0 || this.accountStatus == null)
        }

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {
                    this.lovs = data;
                    this.accountTypes = this.lovs.filter(v => v.lovType == domains.LovType.ACCOUNT_TYPE
                        && (v.value == domains.InvestmentType.INDIVIDUAL_HOLDINGS
                            || v.value == domains.InvestmentType.MANAGED_MODELS
                            || v.value == domains.InvestmentType.SMA));
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        $onInit(): void {
            if (this.filterable) {
                this.loadLovs();
            }

            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.impersonatedByServicer = (this.user.impersonatedByRole == "SERVICER" || this.user.impersonatedByRole == "SERVICER_LEAD" || this.user.impersonatedByRole == "SERVICER_ADMIN")
            });

            this.adminMode = this.advisorService.isAdminModeEnabled();
            this.loadAccounts();
        }
        
    }
    
    class AccountList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {      
                accountStatus: "<",
                investorId: "<",
                householdId: "<",
                allowRename: "<",
                showClosedOption: "<",
                filterable: "<",
                $router: "<"
            };
            this.controller = AccountListController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/shared/common/account-list.html";
        }
    }
    angular.module(Constants.APP).component("accountList", new AccountList());

}